module.exports = __webpack_public_path__ + "img/chinese-logo.07c203d7.png";